import { render, staticRenderFns, recyclableRender, components } from "./u-tag.vue?vue&type=template&id=3732d7af&scoped=true&"
var renderjs
import script from "./u-tag.vue?vue&type=script&lang=js&"
export * from "./u-tag.vue?vue&type=script&lang=js&"
import style0 from "./u-tag.vue?vue&type=style&index=0&id=3732d7af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3732d7af",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-tag/u-tag.vue"
export default component.exports